interface Dictionary<T> {
    [key: string]: T;
}

export class GuidelineFunctionTemplate {
    name?: string;
    description?: string;
    params_schema?: Dictionary<string>;
    func_name?: string;

    constructor(name?: string, description?: string, params_schema?: Dictionary<string>, func_name?: string) {
        this.name = name;
        this.description = description;
        this.params_schema = params_schema;
        this.func_name = func_name;
    }

    toPrimitive(): Dictionary<any> {
        return { ...this };
    }
}

export class ConditionTemplate extends GuidelineFunctionTemplate {
    constructor(name?: string, description?: string, params_schema?: Dictionary<string>, func_name?: string) {
        super(name, description, params_schema, func_name);
    }
}

export class ConsequenceTemplate extends GuidelineFunctionTemplate {
    constructor(name?: string, description?: string, params_schema?: Dictionary<string>, func_name?: string) {
        super(name, description, params_schema, func_name);
    }
}

export class Guideline {
    id?: number;
    user_id?: number;
    username?: string;
    company_id?: number;
    company_name?: string;
    params?: Dictionary<any>;
    condition?: string;
    consequence?: string;
    description?: string;

    constructor(id?: number, user_id?: number, username?:string, company_id?: number, company_name?: string, params?: Dictionary<any>, condition?: string, consequence?: string, description?: string) {
        this.id = id;
        this.user_id = user_id;
        this.username = username;
        this.company_id = company_id;
        this.company_name = company_name;
        this.params = params;
        this.condition = condition;
        this.consequence = consequence;
        this.description = description;
    }

    toPrimitive(): Dictionary<any> {
        return { ...this };
    }
}
